export default (id = 'quiz-widget', openType = true, after = null) => {
  const mountedElem = document.querySelector(`#${id}`)
  const body = document.querySelector('body')
  const html = document.querySelector('html')

  if (mountedElem) {
    mountedElem.remove()
  }

  const position = after ? 'afterend' : 'beforeend'
  const element = after ? document.querySelector('.' + after) : body

  element.insertAdjacentHTML(position, `<div id="${id}" />`)

  html.style.scrollBehavior = 'smooth'
  body.style.scrollBehavior = 'smooth'
  body.style.minHeight = '100vh'
}
